import { render, staticRenderFns } from "./MonetaryDashboard.vue?vue&type=template&id=010b3015&scoped=true&"
import script from "./MonetaryDashboard.vue?vue&type=script&lang=js&"
export * from "./MonetaryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryDashboard.vue?vue&type=style&index=0&id=010b3015&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b3015",
  null
  
)

export default component.exports